module.exports = __webpack_public_path__ + "img/requests.9b52ae7d.svg";